import React, { Component } from 'react'
import { superAdminLoginRes, superAdminLoginTodo } from "redux/slice/super-admin/login/Login";
import { toast, ToastContainer } from "react-toastify";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { withRouter } from 'react-router-dom';
import { Col, Container, Row, Alert, Label } from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import * as Yup from "yup";
import { superAdminSchema } from './Validation';

class SuperAdminLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spiner: false,
            values: {
                email: '',
                password: ''
            }
        };
    }

    superAdminLogin_res = () => {
        if (superAdminLoginRes && superAdminLoginRes.success) {
            toast.success(superAdminLoginRes && superAdminLoginRes.message, { position: "bottom-right" });
            localStorage.setItem('user_id', superAdminLoginRes.data.userId);
            localStorage.setItem('name', superAdminLoginRes.data.username);
            localStorage.setItem('user_token', superAdminLoginRes?.data?.token)
            // localStorage.setItem('userRole', superAdminLoginRes.data.is_super_admin === '1' ? 'superadmin' : 'dealer');
            // localStorage.setItem("actions", superAdminLoginRes.data.is_super_admin === '1' ? JSON.stringify(routeURL) : JSON.stringify(dealerRouteURL));

            setTimeout(() => {
                this.props.history.push('/superadmin/dashboard');
            }, 1500);
        } else {
            toast.error(superAdminLoginRes && superAdminLoginRes.message, { position: "bottom-right" });
            this.setState({ spiner: false });
        }
    
    }



    handleSubmit = (values) => {
        this.setState({ spiner: true });
        const { dispatch } = this.props;
        dispatch(superAdminLoginTodo(values)).then(() => this.superAdminLogin_res());
        
    }
    render() {
        return (
            <>
                <div className="mt-4">

                    <Formik
                        initialValues={this.state.values}
                        validationSchema={superAdminSchema}
                        onSubmit={this.handleSubmit}
                    >
                        {({
                            values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                            <Form>
                                <div className="mb-3">
                                    <Label for="email" className="form-label">  User Name </Label>
                                    <Field name="email" placeholder="Enter email" type="text" className="form-control"
                                        value={values.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur} />
                                    {errors.email && touched.email ? (<span className='text-danger text-start' >{errors.email}</span>) : null}

                                </div>
                                <div className="mb-3">
                                    <div className="float-end">
                                        <Link to="/pages-forgot-pwd-2" className="text-muted"  > Forgot password? </Link>
                                    </div>
                                    <Label for="password" className="form-label"> Password</Label>
                                    <Field name="password" placeholder="Enter Password" type="password" autoComplete="true" className="form-control"
                                        value={values.password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.password && touched.password ? (<span className='text-danger text-start' >{errors.password}</span>) : null}
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="remember-check" />
                                    <label className="form-check-label" htmlFor="remember-check" >
                                        Remember me
                                    </label>
                                </div>
                                <div className="mt-3 d-grid">
                                    <button className="btn btn-primary btn-block " type="submit" >
                                        {this.state.spiner ? <> <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                                            <span>Log In....</span> </> : <span>Log In</span>}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </>
        )
    }
}
export default connect()(withRouter(SuperAdminLogin));
